import ArrayProxy from '@ember/array/proxy';
import { computed, get } from '@ember/object';

/*
  - filters allContent so that 'content' only includes persisted records.
    - it filters out new and destroyed records

  TODO: this still doesn't work but one day I'll figure it out
*/
export default ArrayProxy.extend({
  content: computed('allContent.@each.{isDeleted,isNew}', function () {
    return this.allContent.filter((item) => {
      return !get(item, 'isDeleted') && !get(item, 'isNew');
    });
  }),
});
